var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeyNicIconOnly = function SvgHeyNicIconOnly(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 0v30H0V0h30z",
    id: "bpb4ec7cza"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#bpb4ec7cza"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(1.8 .6)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#038AB7",
    x: 0.785,
    y: 19.97,
    width: 21.793,
    height: 4.094,
    rx: 1.212
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#038AB7",
    x: 5.207,
    y: 12.229,
    width: 21.793,
    height: 4.094,
    rx: 1.212
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#038AB7",
    x: 0.865,
    y: 4.751,
    width: 21.793,
    height: 4.094,
    rx: 1.212
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.987 11.685C5.882 7.49 4.194 5.92 0 6.118 4.193 5.921 5.8 4.195 5.695 0c.105 4.195 1.793 5.765 5.987 5.567-4.193.198-5.8 1.923-5.695 6.118zM17.783 28.8c-.119-4.772-2.04-6.558-6.81-6.333 4.77-.225 6.598-2.188 6.478-6.96.12 4.772 2.04 6.558 6.811 6.333-4.77.225-6.598 2.188-6.479 6.96z",
    fill: "#F2BD66"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeyNicIconOnly);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HeyNicIconOnly.e33e155c0aa62cc544eed994f872590d.svg";